import { ILoadedVenue } from '$models'

/**
 * Above this many venues the dropdown panel shows a type-to-filter search field
 * at the top; below it the list is short enough to scan at a glance.
 */
export const VENUE_SEARCH_THRESHOLD = 15

/**
 * Case-insensitively filters venues on their name. An empty (or whitespace-only)
 * query returns the venues untouched so the panel renders the full list until
 * the user actually types something.
 */
export function filterVenuesByQuery<T extends ILoadedVenue>(
  venues: readonly T[],
  query: string
): readonly T[] {
  const needle = query.trim().toLowerCase()

  if (!needle) {
    return venues
  }

  return venues.filter((venue) => venue.name?.toLowerCase().includes(needle))
}
